export const MINUTES_SAVED_PER_QUESTION = 5

export const SECONDS_TO_MILLIS = 1000
export const MINUTES_TO_MILLIS = 1000 * 60
export const HOURS_TO_MILLIS = 1000 * 60 * 60
export const DAYS_TO_MILLIS = 1000 * 60 * 60 * 24
export const YEARS_TO_MILLIS = 1000 * 60 * 60 * 24 * 365

export const MINUTES_TO_SECONDS = 60
export const HOURS_TO_SECONDS = 60 * 60
export const DAYS_TO_SECONDS = 60 * 60 * 24
export const YEARS_TO_SECONDS = 60 * 60 * 24 * 365

type WithExecutionTimeReturn<T> = { result: T; executionTimeMs: number }

export function withExecutionTime<T>(fn: () => Promise<T>): Promise<WithExecutionTimeReturn<T>>
export function withExecutionTime<T>(fn: () => T): WithExecutionTimeReturn<T>
export function withExecutionTime<T>(
  fn: () => T | Promise<T>,
): WithExecutionTimeReturn<T> | Promise<WithExecutionTimeReturn<T>> {
  const startMs = performance.now()
  const result = fn()
  if (result instanceof Promise) {
    return result.then((value) => ({
      result: value,
      executionTimeMs: Math.round(performance.now() - startMs),
    }))
  }
  return {
    result,
    executionTimeMs: Math.round(performance.now() - startMs),
  }
}
